import React from 'react'

import { useSelector } from 'react-redux'

import { getSettingsState } from '../../store/selectors'
import { getUIState } from '../../../../utils/selectors'

import {
  CarriedMember,
  CarryingMember,
  CountrySelection,
  ConnectionSelection,
  HangerOptions,
  JobSettings,
} from './components'
import { LoadingIndicator } from '../../../../components'

import { CONNECTION_TYPE } from '../../common/constants'

import { RenderAorB, RenderIf } from '../../../../utils/fns'
import { LOADING } from '../../../../utils/constants'

const Input = (props) => {
  const uiLoading = useSelector((state) => getUIState(state).loading)
  const { country, connectionType } = useSelector(getSettingsState)

  return (
    <div className="inputSectionWrapper" {...props}>
      <div className="paneHeader">
        <div className="paneHeader__staticHeading">
          <div className="d-flex justify-between">
            <span>Input</span>
            <CountrySelection country={country} connectionType={connectionType} />
          </div>
        </div>
      </div>
      <div className="inputSection">
        {RenderAorB(
          uiLoading === LOADING.SUCCEEDED,
          <div className="container-fluid">
            <ConnectionSelection country={country} connectionType={connectionType} />
            <JobSettings country={country} connectionType={connectionType} />
            {[CarryingMember, CarriedMember].map((element, key) =>
              React.createElement(element, {
                key,
                connectionType,
                country,
              }),
            )}
            {RenderIf(
              connectionType !== CONNECTION_TYPE.MULTI_TRUSS,
              <HangerOptions connectionType={connectionType} />,
            )}
          </div>,
          <LoadingIndicator />,
        )}
      </div>
    </div>
  )
}

export default Input
